<div class="spinner-wrapper" [class.not-fixed]="!fullScreen" *ngIf="loading">
  <div [class.spinner-background]="fullScreen"></div>
  <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
